/* Options:
Date: 2023-04-04 10:01:12
Version: 5.70
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:54235

//GlobalNamespace: 
//AddServiceStackTypes: True
AddResponseStatus: True
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IPost
{
}

export interface IGet
{
}

export class IntervenorDataDto
{
    public firstName: string;
    public lastName: string;
    public titles: { [index: string]: string; };
    public profilePictureUrl: string;

    public constructor(init?: Partial<IntervenorDataDto>) { (Object as any).assign(this, init); }
}

export class ServiceInformationDto
{
    public appointmentBookingKey: string;
    public serviceLocalizedNames: { [index: string]: string; };
    public startDate: string;
    public endDate: string;
    public employeeId: string;
    public assignedPhysician: IntervenorDataDto;

    public constructor(init?: Partial<ServiceInformationDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1, EmitDefaultValue=false)
    public errorCode: string;

    // @DataMember(Order=2, EmitDefaultValue=false)
    public fieldName: string;

    // @DataMember(Order=3, EmitDefaultValue=false)
    public message: string;

    // @DataMember(Order=4, EmitDefaultValue=false)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export enum SatisfactoryLevel
{
    Neutral = 0,
    Unsatisfactory = 1,
    Satisfactory = 2,
}

export enum TypeOfFinalTransaction
{
    None = 0,
    /**
     * @deprecated
     */
    NewAppointmentCreatedAndConfirmed = 1,
    ExistingAppointmentConfirmed = 2,
    CancelledOnTheirOwn = 3,
    EncounteredError = 4,
    PatientInformedOfLateAppointments = 5,
    PatientInformedOfFutureOnlyAppointments = 6,
}

export enum ErrorCodes
{
    None = 0,
    BarcodeUnreadable = 1,
    MultiplePatientsFound = 2,
    NoPatientsFound = 3,
    NoAppointmentsFound = 4,
    InvalidHealthcardNumber = 5,
    InvalidLoginInformation = 6,
    UnableToCreateNewPatient = 7,
    UnableToLogin = 8,
    UnableToUpdatePatientInformation = 9,
    UnableToGetUserInfoFromSession = 10,
    UnableToUpdateAppointmentStatus = 11,
    CantLoadCache = 12,
    MaximumNumberOfAttemptsReached = 13,
    HealthCardExpired = 14,
    NoAddressesFound = 15,
    AppointmentAlreadyExists = 16,
    NoAvailableAppointments = 17,
    NotAbleToBookNewAppointment = 18,
    AccountIsLockedDueToTooManyInvalidLogins = 19,
    AccountHasBeenLockedByAnAdministrator = 20,
    AccountLockedDueToInactivity = 21,
    InvalidUserNameOrPassword = 22,
    AccountNotActiveYet = 23,
    AccountDeactivated = 24,
    AccountLockedDueToInactivityOrHasPassedDeactivatedDate = 25,
    PostalCodeCheckUnsuccessful = 26,
}

export class AppointmentDataDto
{
    public appointmentId: string;
    public scheduledDateTime: string;
    public intervenors: IntervenorDataDto[];
    public stateCode: string;
    public siteId: string;

    public constructor(init?: Partial<AppointmentDataDto>) { (Object as any).assign(this, init); }
}

export class CategorizedAppointmentDataDto
{
    public lateAppointments: AppointmentDataDto[];
    public validAppointments: AppointmentDataDto[];
    public futureAppointments: AppointmentDataDto[];

    public constructor(init?: Partial<CategorizedAppointmentDataDto>) { (Object as any).assign(this, init); }
}

export class AppointmentServiceItemSummaryDto
{
    public specializationDictionaryId: string;
    public specialtyLookupId: string;
    public siteId: string;
    public employeeId: string;
    public employeeContactId: string;
    public localizedNames: { [index: string]: string; };
    public localizedDescriptions: { [index: string]: string; };
    public localizedDisclaimers: { [index: string]: string; };
    public appointmentTypeId: string;
    public appointmentTypeEntityType: string;
    public defaultDuration: number;
    public longDuration: number;
    public price: number;

    public constructor(init?: Partial<AppointmentServiceItemSummaryDto>) { (Object as any).assign(this, init); }
}

export class FeatureSwitchDto
{
    public patientInformationModificationEnabled: boolean;
    public regionCodeConfirmationEnabled: boolean;
    public displayMyleProfilePictureEnabled: boolean;
    public healthCardExpiryCheckinStopEnabled: boolean;
    public satisfactorySurveyEnabled: boolean;
    public debugWindowModeEnabled: boolean;
    public preferredPharmacyEditionEnabled: boolean;
    public healthCardManualEntryOnlyEnabled: boolean;

    public constructor(init?: Partial<FeatureSwitchDto>) { (Object as any).assign(this, init); }
}

export class LanguageResourceDto
{
    public adminOptions: { [index: string]: string; };
    public contactPoint: { [index: string]: string; };
    public errors: { [index: string]: string; };
    public individualPrefix: { [index: string]: string; };
    public labels: { [index: string]: string; };
    public countries: { [index: string]: string; };
    public regions: { [index: string]: { [index:string]: string; }; };
    public messagesAndInstructions: { [index: string]: string; };
    public phoneType: { [index: string]: string; };
    public titles: { [index: string]: string; };
    public validation: { [index: string]: string; };
    public sexAtBirth: { [index: string]: string; };
    public genderIdentity: { [index: string]: string; };
    public preferredPronouns: { [index: string]: string; };
    public languages: { [index: string]: string; };

    public constructor(init?: Partial<LanguageResourceDto>) { (Object as any).assign(this, init); }
}

export class LanguageResourceServiceDto
{
    public english: LanguageResourceDto;
    public french: LanguageResourceDto;
    public spanish: LanguageResourceDto;

    public constructor(init?: Partial<LanguageResourceServiceDto>) { (Object as any).assign(this, init); }
}

export class SiteInformation implements ISiteInformation
{
    public id: string;
    public name: string;
    public localizedKioskInstruction: Record<string, string>;
    public parentSiteId: string

    public constructor(init?: Partial<SiteInformation>) { (Object as any).assign(this, init); }
}

export class MyleInstanceClinicSettings
{
    public enablePatientNotifiableContactPoints: boolean;

    public enableContactDirectory: boolean;

    public enableKioskMultiSiteCheckin: boolean;

    public constructor(init?: Partial<MyleInstanceClinicSettings>) { (Object as any).assign(this, init); }
}

export enum HealthCardType
{
    CA_QC_RAMQ = 0,
    CA_ON_OHIP = 1,
    CA_NB_MEDICARE = 2,
    CA_BC_MSP = 3,
    MX_ALL_CURP = 4,
}

export class HealthCardTypeInfo
{
    public id: string;
    public countryCode: string;
    public regionCode: string;
    public cardProvider: string;
    public cardNumberMask: string;
    public cardNumberRegex: string;
    // @Ignore()
    public cardTypeCode: HealthCardType;

    public constructor(init?: Partial<HealthCardTypeInfo>) { (Object as any).assign(this, init); }
}

export enum InteractionType
{
    Unknown = 0,
    PatientSearchSuccessful = 1,
    MultiplePatientsFoundDuringSearch = 2,
    NoPatientFoundWhenSearched = 3,
    ExistingAppointmentsSearchedAndFound = 4,
    PatientInformationModified = 5,
    NewAppointmentBooked = 6,
    ExistingAppointmentConfirmed = 7,
    PatientCancelledCheckinManually = 8,
    InactivityDisplayedAndTriggered = 9,
    ExistingAppointmentsNotFoundForToday = 10,
    UnableToUpdatePatientInformation = 11,
    UnableToGetNewAvailableAppointments = 12,
    UnableToGetAvailabilityServiceSummaryForToday = 13,
    UnableToBookNewAppointment = 14,
    ExistingAppointmentFoundForTodayButNotValidForCheckin = 15,
    DidNotAnswerSatisfactorySurvey = 16,
    ValidAppointmentAvailabilityFoundForCheckin = 17,
    NoValidAppointmentAvailabilityFoundForCheckin = 18,
    UnableToConfirmExistingAppointment = 19,
    HealthCardExpiredTriggered = 20,
    UnableValidatePostalCodeNoAddressesFoundForPatient = 21,
    PatientUnableToConfirmIdentityByPostalConfirmation = 22,
    AnsweredSatisfactionSurvey = 23,
}

export enum ClientEventScreen
{
    None = 0,
    HealthCardManualEntryPostalCodeVerification = 1,
    PatientOverview = 2,
    ExistingAppointmentConfirmation = 3,
    BookNewAppointment = 4,
    SatisfactorySurvey = 5,
    AcquireHealthCardManualMode = 6,
}

export class AddressCheckin implements IAddressCheckin
{
    public streetAddress: string;
    public city: string;
    public country: string;
    public state: string;
    public zipCode: string;
    public isPreferred: boolean;
    public contactId: string;
    public contactPointType: string;
    public contactPointId: string;

    public constructor(init?: Partial<AddressCheckin>) { (Object as any).assign(this, init); }
}

export class DemographicsCheckin implements IDemographicsCheckin
{
    public dateOfBirth: string;
    public firstName: string;
    public lastName: string;
    public sexAtBirth: string;
    public genderIdentity: string;
    public preferredName: string;
    public preferredPronouns: string;
    public specifiedPreferredPronouns: string;
    public prefix: string;

    public constructor(init?: Partial<DemographicsCheckin>) { (Object as any).assign(this, init); }
}

export class EmailCheckin implements IEmailCheckin
{
    public address: string;
    public contactPointId: string;
    public isOkToContact: boolean;
    public contactPointType: string;
    public notificationsEnabled: boolean;

    public constructor(init?: Partial<EmailCheckin>) { (Object as any).assign(this, init); }
}

export class HealthCardCheckin implements IHealthCardCheckin
{
    public number: string;
    public expiryDate: string;

    public constructor(init?: Partial<HealthCardCheckin>) { (Object as any).assign(this, init); }
}

export class PhoneCheckin implements IPhoneCheckin
{
    public contactId: string;
    public phoneType: string;
    public isPreferred: boolean;
    public number: string;
    public countryLookupId: string;
    public contactPointId: string;
    public contactPointType: string;
    public extension: string;
    public notificationsEnabled: boolean;

    public constructor(init?: Partial<PhoneCheckin>) { (Object as any).assign(this, init); }
}

export class PreferredPharmacyCheckin implements IPreferredPharmacyCheckin
{
    public directoryPharmacyId: string;
    public id: number;
    public name: string;
    public address: string;
    public phone: string;
    public fax: string;
    public banner: string;
    public isMylePharmacy: boolean;

    public constructor(init?: Partial<PreferredPharmacyCheckin>) { (Object as any).assign(this, init); }
}

export class PatientIndividualInformationDto
{
    public patientContactFacetId: string;
    public patientId: string;
    public addresses: AddressCheckin[];
    public demographics: DemographicsCheckin;
    public emails: EmailCheckin[];
    public healthCard: HealthCardCheckin;
    public phones: PhoneCheckin[];
    public preferredPharmacy: PreferredPharmacyCheckin;

    public constructor(init?: Partial<PatientIndividualInformationDto>) { (Object as any).assign(this, init); }
}

export class PharmacyDto {
    public name: string;
    public address: string;
    public phone: string;
    public fax: string;
    public banner: string;
    public email: string;
    public id: number;
    public directoryPharmacyId: string; // Using string to represent GUID
    public isMylePharmacy: boolean;

    public constructor(init?: Partial<PharmacyDto>) {
        Object.assign(this, init);
    }
}

export enum HealthCardAcquisitionType
{
    Unknown = 0,
    BarCodeScanner = 1,
    ManualEntry = 2,
}

export interface ISiteInformation
{
    id: string;
    name: string;
}

export interface IAddressCheckin
{
    city: string;
    contactId: string;
    contactPointId: string;
    contactPointType: string;
    country: string;
    state: string;
    streetAddress: string;
    zipCode: string;
    isPreferred: boolean;
}

export interface IDemographicsCheckin
{
    dateOfBirth: string;
    firstName: string;
    sexAtBirth: string;
    genderIdentity: string;
    lastName: string;
    preferredName: string;
    preferredPronouns: string;
    specifiedPreferredPronouns: string;
    prefix: string;
}

export interface IEmailCheckin
{
    address: string;
    contactPointId: string;
    contactPointType: string;
    isOkToContact: boolean;
    notificationsEnabled: boolean;
}

export interface IHealthCardCheckin
{
    expiryDate: string;
    number: string;
}

export interface IPhoneCheckin
{
    contactId: string;
    contactPointId: string;
    contactPointType: string;
    countryLookupId: string;
    extension: string;
    number: string;
    phoneType: string;
    isPreferred: boolean;
    notificationsEnabled: boolean;
}

export interface IPreferredPharmacyCheckin
{
    directoryPharmacyId: string;
    id: number;
    name: string;
    address: string;
    phone: string;
    fax: string;
    banner: string;
    isMylePharmacy: boolean;
}

export class AnswerToSatisfactionSurveyResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AnswerToSatisfactionSurveyResponse>) { (Object as any).assign(this, init); }
}

export class GetAppointmentsResponse
{
    public categorizedAppointmentData: CategorizedAppointmentDataDto;
    public appointmentExists: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAppointmentsResponse>) { (Object as any).assign(this, init); }
}

export class SearchPharmaciesResponse 
{
    public searchPharmacyResults: PharmacyDto[];
    public pageNumber: number;
    public pageSize: number;
    public totalCount: number;

    public constructor(init?: Partial<SearchPharmaciesResponse>) { (Object as any).assign(this, init); }
}

export class GetClinicInformationResponse
{
    public featureFlags: FeatureSwitchDto;
    public responseStatus: ResponseStatus;
    public languageResourceServiceDto: LanguageResourceServiceDto;
    public clinicName: string;
    public frText: string;
    public enText: string;
    public esText: string;
    public clinicCountry: string;
    public clinicRegion: string;
    public sites: SiteInformation[];
    public myleClinicSettings: MyleInstanceClinicSettings;
    public healthCards: HealthCardTypeInfo[];

    public constructor(init?: Partial<GetClinicInformationResponse>) { (Object as any).assign(this, init); }
}

export class LogFrontEndExceptionResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<LogFrontEndExceptionResponse>) { (Object as any).assign(this, init); }
}

export class LogInteractionEventResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<LogInteractionEventResponse>) { (Object as any).assign(this, init); }
}

export class UpdatePatientInfoResponse
{
    public isSuccessful: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdatePatientInfoResponse>) { (Object as any).assign(this, init); }
}

export class StartApplicationResponse
{
    public english: LanguageResourceDto;
    public french: LanguageResourceDto;
    public spanish: LanguageResourceDto;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StartApplicationResponse>) { (Object as any).assign(this, init); }
}

export class ConfirmedArrivedResponse
{
    public isSuccessful: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ConfirmedArrivedResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientInfoResponse
{
    public patientIndividualInformation: PatientIndividualInformationDto;
    public numberOfPatientsFound: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetPatientInfoResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @Route("/satisfactorySurvey/answer", "POST")
export class AnswerToSatisfactionSurveyRequest implements IReturn<AnswerToSatisfactionSurveyResponse>
{
    public satisfactoryLevel: SatisfactoryLevel;
    public typeOfFinalTransaction: TypeOfFinalTransaction;
    public errorCode: ErrorCodes;

    public constructor(init?: Partial<AnswerToSatisfactionSurveyRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new AnswerToSatisfactionSurveyResponse(); }
    public getTypeName() { return 'AnswerToSatisfactionSurveyRequest'; }
}

// @Route("/appointments/{patientId}", "GET")
export class GetAppointmentsRequests implements IReturn<GetAppointmentsResponse>
{
    public patientId: string;

    public constructor(init?: Partial<GetAppointmentsRequests>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAppointmentsResponse(); }
    public getTypeName() { return 'GetAppointmentsRequests'; }
}

// @Route("/dictionaries/pharmacies/search", "POST")
export class SearchPharmaciesRequest implements IReturn<SearchPharmaciesResponse>
{
    public SearchString: string;
    public PageSize: number | null;
    public PageNumber: number | null;
    public IsContactDirectoryEnabled: boolean;
    public EnableExtendedGeographicalSearch: boolean;

    public constructor(init?: Partial<SearchPharmaciesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SearchPharmaciesResponse(); }
    public getTypeName() { return 'SearchPharmaciesRequest'; }
}

// @Route("/clinicInformation/", "GET")
export class GetClinicInformationRequest implements IReturn<GetClinicInformationResponse>
{

    public constructor(init?: Partial<GetClinicInformationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetClinicInformationResponse(); }
    public getTypeName() { return 'GetClinicInformationRequest'; }
}

// @Route("/log/frontEndException/", "POST")
export class LogFrontEndExceptionRequest implements IReturn<LogFrontEndExceptionResponse>
{
    public error: Object;

    public constructor(init?: Partial<LogFrontEndExceptionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new LogFrontEndExceptionResponse(); }
    public getTypeName() { return 'LogFrontEndExceptionRequest'; }
}

// @Route("/log/interactionEvent/", "POST")
export class LogInteractionEventRequest implements IReturn<LogInteractionEventResponse>
{
    public interactionType: InteractionType;
    public clientEventScreen: ClientEventScreen;

    public constructor(init?: Partial<LogInteractionEventRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new LogInteractionEventResponse(); }
    public getTypeName() { return 'LogInteractionEventRequest'; }
}

// @Route("/patientInfo/{PatientId}", "PUT")
export class UpdatePatientInfo implements IReturn<UpdatePatientInfoResponse>
{
    public patientInfo: PatientIndividualInformationDto;

    public constructor(init?: Partial<UpdatePatientInfo>) { (Object as any).assign(this, init); }
    public createResponse() { return new UpdatePatientInfoResponse(); }
    public getTypeName() { return 'UpdatePatientInfo'; }
}

// @Route("/startApplication/", "POST")
export class StartApplicationRequest implements IReturn<StartApplicationResponse>
{
    public siteName: string;
    public siteId: string[];
    public sessionTimeSpan: number;
    public latenessDelay: number;
    public maximumTimeGapBetweenAppointments: number;

    public constructor(init?: Partial<StartApplicationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new StartApplicationResponse(); }
    public getTypeName() { return 'StartApplicationRequest'; }
}

// @Route("/confirmedArrived/", "POST")
export class ConfirmedArrivedRequest implements IReturn<ConfirmedArrivedResponse>
{
    public appointmentIds: string[];

    public constructor(init?: Partial<ConfirmedArrivedRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConfirmedArrivedResponse(); }
    public getTypeName() { return 'ConfirmedArrivedRequest'; }
}

// @Route("/patientInfo/{HealthCardNumber}", "GET")
export class GetPatientInfo implements IReturn<GetPatientInfoResponse>
{
    public healthCardNumber: string;
    public acquisitionType: HealthCardAcquisitionType;

    public constructor(init?: Partial<GetPatientInfo>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientInfoResponse(); }
    public getTypeName() { return 'GetPatientInfo'; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe: boolean;

    // @DataMember(Order=8)
    public continue: string;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=16)
    public useTokenCookie: boolean;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public createResponse() { return new AuthenticateResponse(); }
    public getTypeName() { return 'Authenticate'; }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public createResponse() { return new AssignRolesResponse(); }
    public getTypeName() { return 'AssignRoles'; }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public createResponse() { return new UnAssignRolesResponse(); }
    public getTypeName() { return 'UnAssignRoles'; }
}




// WEBPACK FOOTER //
// ./src/dtos/KioskDtos.dtos.ts